import * as React from 'react';
import { MiniCalendarComponent } from '../../common/components/MiniCalendarComponent';
import PropTypes from 'prop-types';
import { PriceSection } from '../../common/components/PriceSection';
import { imageBaseURL } from '../../common/constants/CommonConstants';
import { TertiaryLink } from "@sfly/uig-button";

// For Lazy Loading
import { LazyLoadImage } from 'react-lazy-load-image-component';

export class CalendarTypesComponent extends React.Component {

    constructor(props, state) {
        super(props, state);

        this.state = {
            calendarTypes: props.calendarTypes,
            calendarTypesWithDiscount: {},
            calendarTypesWithPriceError: {}
        };

        this.checkTypeForDiscount = this.checkTypeForDiscount.bind(this);
        this.checkTypeForPricingError = this.checkTypeForPricingError.bind(this);
    }

    componentWillReceiveProps() {
        if(this.props.calendarTypes && this.props.calendarTypes.length > 0) {
            this.setState({
                calendarTypes: this.props.calendarTypes.sort((cal1, cal2) => cal1.rank - cal2.rank).filter(calendar => calendar.isActive)
            });

            this.numberOfCalTypes = this.state.calendarTypes.length;
        }
    }

    // This method will return class 'cal-data' along with classes 'cal-data-padding' and 'cal-discount-text-padding'
    // based on isCTAButton and calendarTypesWithDiscount and used by a calendar type,
    // else will return 'cal-data' by default.
    getClassNames(calendar) {
        let classNames = 'cal-data';

        if(calendar.isCTAButton) {
            classNames += ' cal-data-padding';
        }
        if(this.state.calendarTypesWithDiscount[calendar.id]) {
            classNames += ' cal-discount-text-padding';
        }
        return classNames;
    }

    // This method gets the type from PriceSection component and set the value for provided type to 'true' in calendarTypesWithDiscount state.
    // calendarTypesWithDiscount state is used to apply special css or other treatments to discounted calendar types.
    checkTypeForDiscount(type) {
        const currentTypesWithDiscount = this.state.calendarTypesWithDiscount;

        if(!currentTypesWithDiscount[type]) {
            currentTypesWithDiscount[type] = true;

            this.setState({
                calendarTypesWithDiscount: currentTypesWithDiscount
            });
        }
    }

    // This method gets the type from PriceSection component and set the value for provided type to 'true' in calendarTypesWithPriceError state.
    // calendarTypesWithPriceError state is used to apply special css or other treatments to calendar types with no price.
    checkTypeForPricingError(type) {
        const currentTypesWithPricingError = this.state.calendarTypesWithPriceError;

        if(!currentTypesWithPricingError[type]) {
            currentTypesWithPricingError[type] = true;

            this.setState({
                calendarTypesWithPriceError: currentTypesWithPricingError
            });
        }
    }

    renderCalendarTypes() {
        return (
            <div className={`calendar-types${this.numberOfCalTypes > 3 ? ` cal-container-${this.numberOfCalTypes}` : ''}`}>
                {
                    this.state.calendarTypes.map((calendar, index) => (
                        <div id={calendar.id} key={index} className={`calendar${calendar.isActiveOnMobile ? '' : ' hide-on-mobile'}`}>
                            <div className={'cal-thumb-image'}>
                                <TertiaryLink href={calendar.ctaLink} aria-labelledby={`${calendar.id}-heading ${calendar.id}-sub-heading price-section-${calendar.id}`}>
                                    <LazyLoadImage alt={calendar.altText || ''} src={imageBaseURL + calendar.imageURL} />
                                </TertiaryLink>
                            </div>
                            <div className={this.getClassNames(calendar)}>
                                <div id={`${calendar.id}-heading`} className={'tile-heading'}>{calendar.heading}</div>
                                <div id={`${calendar.id}-sub-heading`} className={'tile-sub-heading'}>{calendar.subHeading}</div>
                                {calendar.enableMiniCalendar ? <MiniCalendarComponent useShortHand={true} /> : null}
                                <div className={`cta-area${this.state.calendarTypesWithPriceError[calendar.id] ? ' no-price' : ''}`}>
                                    {this.renderCTASection(calendar)}
                                    {this.props.pricingDetails && this.props.pricingDetails.length > 0 ?
                                        <PriceSection contentId={calendar.id} pricingDetails={this.props.pricingDetails} checkForDiscount={this.checkTypeForDiscount} checkForError={this.checkTypeForPricingError} /> :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                        ))
                }
            </div>
        );
    }

    renderCTASection(content) {
        if(!content.ctaLink && content.ctaLink === '') return null;

        return(
            <div className={'cta-link'}>
                <a href={content.ctaLink} aria-label={`${content.ctaLinkLable} ${content.heading}`} className={content.isCTAButton ? 'uig-button uig-secondary-button' : ''} aria-describedby={`${content.id}-heading ${content.id}-sub-heading price-section-${content.id}`}>
                    {content.ctaLinkLable}
                </a>
            </div>
        );
    }

    render() {
        if(!this.numberOfCalTypes) {
            return null;
        }

        return(
            <div className={'calendar-types-container'}>
                <h3 className={'section-heading'}>{this.props.calendarTypesSectionHeadings.heading}</h3>
                <div className={'section-sub-heading'}>{this.props.calendarTypesSectionHeadings.subHeading}</div>
                {this.renderCalendarTypes()}
            </div>
        );
    }
}

CalendarTypesComponent.propTypes = {
    calendarTypes: PropTypes.array.isRequired,
    calendarTypesSectionHeadings: PropTypes.object,
    pricingDetails: PropTypes.array
};

CalendarTypesComponent.defaultProps = {
    calendarTypesSectionHeadings: {
        heading: 'Calendars for every space',
        subHeading: 'From cubicles to kitchens, keep track of important dates wherever you are'
    },
    pricingDetails: []
};

